module.exports = "<rect x=\"4\" y=\"9\" width=\"12\" height=\"2\"/>\n<rect x=\"9\" y=\"4\" width=\"2\" height=\"12\"/>\n"